import "./styles/marketing.css";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import WhatsAppFloatingButton from "../b2b/WhatsAppFloatingButton";

interface BusinessHomepageLayoutProps {
	children: React.ReactNode;
}

export function BusinessHomepageLayout({ children }: BusinessHomepageLayoutProps) {
	return (
		<div className="min-h-screen bg-[#0A0E27]">
			<Header />
			{children}
			<Footer />
			<WhatsAppFloatingButton />
		</div>
	);
}
